export function ServerError() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h1>500</h1>
      <p>Something went wrong.</p>
      <p>Please try again later.</p>
    </div>
  );
}
